import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { CustomerListComponent } from "./customer-list.component";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { ReactiveFormsModule } from "@angular/forms";
import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
import { MatIconModule } from "@angular/material/icon";
import { FormsSharedModule } from "@shared/modules/forms-shared.module";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { PaginationModule } from "../pagination/pagination.module";
import { NoItemsLayoutModule } from "../no-items-layout/no-items-layout.module";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { SharedModule } from "@shared/shared.module";
import { CalendarActionsModule } from "@shared/components/calendar-actions/calendar-actions.module";
import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
import { CustomerLogoComponent } from "@shared/components/customer-logo/customer-logo.component";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";

@NgModule({
	declarations: [CustomerListComponent],
	imports: [
		CommonModule,
		MatCardModule,
		MatInputModule,
		FormsSharedModule,
		MatIconModule,
		PaginationModule,
		NoItemsLayoutModule,
		FlexLayoutModule,
		MatButtonModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatPaginatorModule,
		SharedModule,
		CalendarActionsModule,
		MatSlideToggleModule,
		MatTooltipModule,
		CustomerLogoComponent
	],
	exports: [CustomerListComponent]
})
export class CustomerListModule {}
